import { Helmet } from 'react-helmet-async';
import { Compass } from 'lucide-react';
import UnifiedBookingCalendar from './UnifiedBookingCalendar';
import { useBrand } from '../context/BrandContext';

export default function GeneralExpeditions() {
  const { content } = useBrand();

  return (
    <div className="pt-32 pb-24 bg-ows-white min-h-screen relative">
      <Helmet>
        <title>{`${content.expeditionsLabel} | Maritime Overlanding | OWS`}</title>
        <meta name="description" content={content.expeditionsDescription} />
        <meta name="keywords" content="SUP expeditions, paddleboarding day trips, lake crossings, maritime training, outdoor navigation missions" />
      </Helmet>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <div className="h-16 w-16 bg-ows-teal flex items-center justify-center rounded-2xl text-white mx-auto mb-6">
            <Compass className="h-8 w-8" />
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-display font-light uppercase tracking-widest text-ows-dark mb-6 whitespace-pre-line">
            {content.expeditionsTitle}
          </h1>
          <p className="text-lg md:text-xl text-ows-dark/60 max-w-3xl mx-auto font-light leading-relaxed whitespace-pre-line">
            {content.expeditionsDescription}
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
           {/* No type prop means it shows all active slots (day, night, crossing, etc) */}
           <UnifiedBookingCalendar />
        </div>
      </div>
    </div>
  );
}
